export function formatMinutes(minutes: number) {
  try {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    return `${hours}ч. ${remainingMinutes}мин.`;
  } catch (e) {
    return "0ч. 0мин.";
  }
}
